import * as React from "react"
import {Box} from "@mui/material";

import MatcherSkusTargetProduct from "./Product";
import MatcherSKUsTargetActions from "./Actions";


export default function MatcherSkusTarget({ targetIndex, data, thumbnail, handleChangeIndex, isLoadingMapping}) {
    return <Box sx={{
        width: 1,
        height: 1,
        backgroundColor: 'background.neutral',
        borderRadius: 1,
        py: 5,
        px: 6.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        justifyContent: 'flex-start'
    }}>
        <MatcherSKUsTargetActions
            targetIndex={targetIndex}
            handleChangeIndex={handleChangeIndex}
			isLoadingMapping={isLoadingMapping}
        />

        <MatcherSkusTargetProduct data={data} thumbnail={thumbnail} />
    </Box>
}